export default __webpack_public_path__ + "static/media/ToyotaType-Book.a1dc7f70.woff";